import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Search } from "lucide-react";

const MAX_RADIUS_M = 50000;

export function SearchForm({ onSubmit, loading }) {
  const [metier, setMetier] = useState("");
  const [ville, setVille] = useState("");
  const [rayonKm, setRayonKm] = useState(10);
  const [noteMin, setNoteMin] = useState("");
  const [avisMin, setAvisMin] = useState("");
  const [sansSiteUniquement, setSansSiteUniquement] = useState(true);
  const [avecTelephoneUniquement, setAvecTelephoneUniquement] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      metier,
      ville,
      rayon_m: Math.min(Math.round(Number(rayonKm) * 1000), MAX_RADIUS_M),
      filtres: {
        note_min: noteMin === "" ? null : Number(noteMin),
        avis_min: avisMin === "" ? null : Number(avisMin),
        sans_site_uniquement: sansSiteUniquement,
        avec_telephone_uniquement: avecTelephoneUniquement,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="border border-border p-6" data-testid="search-form">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Metier</Label>
          <Input
            data-testid="search-metier-input"
            value={metier}
            onChange={(e) => setMetier(e.target.value)}
            placeholder="Ex: plombier"
            required
            className="rounded-none"
          />
        </div>
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Ville</Label>
          <Input
            data-testid="search-ville-input"
            value={ville}
            onChange={(e) => setVille(e.target.value)}
            placeholder="Ex: Lyon"
            required
            className="rounded-none"
          />
        </div>
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Rayon (km, max 50)</Label>
          <Input
            data-testid="search-rayon-input"
            type="number"
            min={0.5}
            max={50}
            step={0.5}
            value={rayonKm}
            onChange={(e) => setRayonKm(e.target.value)}
            required
            className="rounded-none"
          />
        </div>
        <div className="flex items-end">
          <Button type="submit" data-testid="search-submit-button" disabled={loading} className="w-full rounded-none font-mono uppercase tracking-wider gap-2">
            <Search size={14} /> {loading ? "Recherche..." : "Lancer la recherche"}
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 pt-4 border-t border-border">
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Note minimale</Label>
          <Input
            data-testid="search-note-min-input"
            type="number"
            min={0}
            max={5}
            step={0.1}
            value={noteMin}
            onChange={(e) => setNoteMin(e.target.value)}
            placeholder="Ex: 4"
            className="rounded-none"
          />
        </div>
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Avis minimum</Label>
          <Input
            data-testid="search-avis-min-input"
            type="number"
            min={0}
            value={avisMin}
            onChange={(e) => setAvisMin(e.target.value)}
            placeholder="Ex: 10"
            className="rounded-none"
          />
        </div>
        <div className="flex items-center gap-2 pt-6">
          <Checkbox
            id="sans-site"
            data-testid="search-sans-site-checkbox"
            checked={sansSiteUniquement}
            onCheckedChange={(v) => setSansSiteUniquement(Boolean(v))}
            className="rounded-none"
          />
          <Label htmlFor="sans-site" className="font-mono text-xs uppercase tracking-wider cursor-pointer">
            Uniquement sans site Google
          </Label>
        </div>
        <div className="flex items-center gap-2 pt-6">
          <Checkbox
            id="avec-tel"
            data-testid="search-avec-telephone-checkbox"
            checked={avecTelephoneUniquement}
            onCheckedChange={(v) => setAvecTelephoneUniquement(Boolean(v))}
            className="rounded-none"
          />
          <Label htmlFor="avec-tel" className="font-mono text-xs uppercase tracking-wider cursor-pointer">
            Uniquement avec telephone
          </Label>
        </div>
      </div>
    </form>
  );
}
